<template>
  <v-autocomplete
    v-bind="$attrs"
    v-model="model"
    outlined
    dense
    multiple
    clearable
    :item-text="nameField"
    :item-value="valueField"
    :items="items"
  >
  <template #selection="{ item, index }">
    <v-chip
      v-if="index < 2"
      :key="item[valueField]"
      :value="item"
      :input-value="item"
      class="ma-1"
      :class="chipClass"
      :textColor="chipBorderColor"
      :close="allowSingleDelete"
      @click:close="handleChipDelete(item)"
    >
      <span :title="item[nameField]" class="text-truncate">{{ item[nameField] }}</span>
    </v-chip>
    <span
      v-if="index === 2"
      class="grey--text text--darken-1 text-caption align-self-center font-weight-medium ma-1"
    >
    {{
      $tc("common.others", value.length - 2)
    }}
  </span>
  </template>
  </v-autocomplete>
</template>

<script>
export default {
  name: 'VfAutoSelect',
  props: {
    value: {
      type: Array,
      required: true,
      defaultValue: () => []
    },
    nameField: {
      type: String,
      required: true
    },
    valueField: {
      type: String,
      default: null
    },
    items: {
      type: Array,
      required: true,
      defaultValue: () => []
    },
    allowSingleDelete: {
      type: Boolean,
      default: false
    },
    customChipClass: {
      type: String,
      default: ''
    }
  },
  computed: {
    model: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    },
    chipBackgroundColor () {
      return this.$vuetify.theme.currentTheme.highlight
    },
    chipBorderColor () {
      return this.$vuetify.theme.currentTheme.primary
    },
    chipClass () {
      return this.customChipClass || 'defaultChipClass'
    }
  },
  methods: {
    handleChipDelete (item) {
      let updatedValue
      if (this.valueField) {
        const itemValue = item[this.valueField]
        updatedValue = this.value.filter(val => {
          return typeof val === 'object' ? val[this.valueField] !== itemValue : val !== itemValue
        })
      } else {
        updatedValue = this.value.filter(val => val !== item)
      }
      this.$emit('input', updatedValue)
      this.$emit('item-deleted', item)
    }
  }
}
</script>

<style scoped>
  .defaultChipClass {
    background-color: v-bind(chipBackgroundColor);
    color: v-bind(chipBorderColor);
    border: 1px solid v-bind(chipBorderColor);
    font-size: 0.75rem;
    font-weight: 500;
  }
</style>
